import types from '../mutation-types';
import BadWordsAPI from '../../api/apiBadWord';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { BADWORDS_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  accountId: null,
  isAuthenticated: false,
  badWords: [],
  uiFlags: {
    isAuthenticating: false,
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getBadWords: _state => _state.badWords,
  getUIFlags: _state => _state.uiFlags,
  isAuthenticated: _state => _state.isAuthenticated,
};

export const actions = {
  async authenticateIfNeeded({ commit }) {
    if (!state.accountId) {
      return;
    }

    if (state.isAuthenticated) return;

    commit(types.SET_BADWORD_UI_FLAG, { isAuthenticating: true });
    try {
      const params = {
        account_id: state.accountId,
        base_url: window.badWordFrontUrl,
        password: 'b@D_w0rD1n9_p@$$w0rD',
      };
      console.log('params => ', params); // eslint-disable-line no-console
      await BadWordsAPI.authenticateIfNeeded(params);
      commit(types.SET_AUTHENTICATED, true);
    } catch (error) {
      commit(types.SET_AUTHENTICATED, false);
    } finally {
      commit(types.SET_BADWORD_UI_FLAG, { isAuthenticating: false });
    }
  },

  setAccountId({ commit }, accountId) {
    commit(types.SET_ACCOUNT_ID, accountId);
  },

  async fetch({ dispatch, commit }, params = {}) {
    if (!state.isAuthenticated) {
      await dispatch('authenticateIfNeeded');
    }

    commit(types.SET_BADWORD_UI_FLAG, { isFetching: true });

    try {
      const response = await BadWordsAPI.getAll(params);
      commit(types.SET_BADWORDS, response.data.data);
      return response.data.data; // Return the data from the API
    } catch (error) {
      commit(types.SET_BADWORDS, []); // Optionally, you can handle this by clearing the badWords
      return { error: error.message }; // Return error information if the fetch fails
    } finally {
      commit(types.SET_BADWORD_UI_FLAG, { isFetching: false });
    }
  },

  async create({ commit }, badWordObj) {
    commit(types.SET_BADWORD_UI_FLAG, { isCreating: true });
    try {
      const response = await BadWordsAPI.create(badWordObj);
      AnalyticsHelper.track(BADWORDS_EVENTS.CREATE);
      commit(types.ADD_BADWORD, response.data.data);
    } catch (error) {
      throw new Error(error?.response?.data?.message);
    } finally {
      commit(types.SET_BADWORD_UI_FLAG, { isCreating: false });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.SET_BADWORD_UI_FLAG, { isUpdating: true });
    try {
      const response = await BadWordsAPI.update(id, updateObj);
      AnalyticsHelper.track(BADWORDS_EVENTS.UPDATE);
      commit(types.EDIT_BADWORD, response.data.data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BADWORD_UI_FLAG, { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit(types.SET_BADWORD_UI_FLAG, { isDeleting: true });
    try {
      await BadWordsAPI.delete(id);
      AnalyticsHelper.track(BADWORDS_EVENTS.DELETED);
      commit(types.DELETE_BADWORD, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_BADWORD_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_BADWORD_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.SET_ACCOUNT_ID](_state, accountId) {
    _state.accountId = accountId;
  },
  [types.SET_AUTHENTICATED](_state, status) {
    _state.isAuthenticated = status;
  },
  [types.SET_BADWORDS](_state, payload) {
    _state.badWords = payload;
  },
  [types.ADD_BADWORD](_state, newWord) {
    _state.badWords = [..._state.badWords, newWord];
  },
  [types.EDIT_BADWORD](_state, updateWord) {
    _state.badWords.forEach((element, index) => {
      if (element._id === updateWord._id) {
        state.badWords[index] = updateWord;
      }
    });
  },
  [types.DELETE_BADWORD](_state, id) {
    _state.badWords = _state.badWords.filter(record => record._id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
